import React, { useEffect } from 'react';
import styles from './Engagement.module.scss';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import { useFetch } from 'hooks/useFetch';
import { dashboardEndpoints } from 'hooks/endpoints';
import Loader from 'component/atom/loader/Loader';

const Engagement = ({ startDate, endDate, botId, botType }) => {
  const { data, refetch, isFetching, isLoading } = useFetch(
    ['engagementRate', startDate, endDate, botId, botType],
    dashboardEndpoints.getEngagementRate(startDate, endDate),
    { enabled: false },
    botId ? { botId: botId, chatSource: botType } : {}
  );

  useEffect(() => {
    if (botType !== undefined) {
      refetch();
    }
  }, [startDate, endDate, botType, botId]);

  const currentRate = data?.data?.currentWindow?.engagementRatePercent ?? 0;
  const changePct = data?.data?.percentChangeFromPreviousMonth ?? 0;

  const isPositive = changePct > 0;
  const isNegative = changePct < 0;
  const showArrow = changePct !== 0;

  const color = isNegative ? '#DB161B' : isPositive ? '#01931A' : '#F08800';
  const backgroundColor = isNegative
    ? '#FBE3E4'
    : isPositive
    ? '#E0FFE5'
    : '#FFF7EC';
  const arrowRotation = isPositive ? 'rotate(180deg)' : 'none';

  const formatPercent = (val, sign) => {
    const num = Math.abs(val);
    const str = Number.isInteger(num) ? num : num.toFixed(2);
    return sign + str + '%';
  };

  const formatRate = (val) => {
    const num = val;
    return Number.isInteger(num) ? `${num}%` : `${num.toFixed(2)}%`;
  };

  return (
    <div className={styles['engagement-container']}>
      <div className={styles['title-container']}>
        <SvgWithBranding type='engagement' />
        <span className={styles['title']}>Engagement Rate</span>
      </div>
      <span className={styles['description']}>
        Percentage of users who actively interact with the chatbot during a
        session.
      </span>
      <span className={styles['average']}>
        {isFetching || isLoading ? <Loader /> : formatRate(currentRate)}
      </span>
      {/* <div className={styles['percentage-change-container']}>
        <div
          className={styles['percentage-card']}
          style={{ color, backgroundColor, borderColor: color }}
        >
          {showArrow && (
            <div style={{ transform: arrowRotation }}>
              <SvgWithBranding type='down_arrow' color={color} height={12} />
            </div>
          )}
          <span className={styles['percentage-change']} style={{ color }}>
            {isPositive
              ? formatPercent(changePct, '+')
              : isNegative
              ? formatPercent(changePct, '-')
              : formatPercent(changePct, '')}
          </span>
        </div>
        <span className={styles['duration']}>from last month</span>
      </div> */}
    </div>
  );
};

export default Engagement;
